<script lang="ts">
  import { store } from '$lib/store.svelte';
  import { CATEGORY_LABELS, formatDate } from '$lib/gtd';
  import type { Category } from '$lib/types';

  interface Props { onMessage: (m: string, t?: 'success' | 'warning') => void }
  let { onMessage }: Props = $props();

  const categorias = Object.keys(CATEGORY_LABELS) as Category[];

  // Ítems en vuelo: el botón queda deshabilitado para no crear ideas duplicadas.
  let enviando = $state<string[]>([]);

  async function enviar(id: string) {
    const item = store.archivo.find((i) => i.id === id);
    if (!item || enviando.includes(id) || store.yaEnEmbudo(id)) return;
    enviando = [...enviando, id];
    try {
      await store.enviarAlEmbudo(item);
      onMessage('Enviada al embudo como idea capturada');
    } catch (e) {
      onMessage(e instanceof Error ? e.message : String(e), 'warning');
    } finally {
      enviando = enviando.filter((x) => x !== id);
    }
  }
</script>

<div class="view-title">Archivo GTD</div>
<p class="view-sub">Lo que había antes del embudo. Solo lectura: lo que mandes al embudo se copia, el original no cambia.</p>

{#each categorias as cat}
  {@const items = store.archivo.filter((i) => i.category === cat)}
  {#if items.length > 0}
    <h3 style="margin:var(--space-md) 0 var(--space-xs)">{CATEGORY_LABELS[cat]} ({items.length})</h3>
    {#each items as item (item.id)}
      <div class="item">
        <div style="flex:1;min-width:0">
          <div class="item-text">{item.text}</div>
          <div class="item-meta">
            {#if item.done}<span class="tag">hecha</span>{/if}
            <span>{formatDate(item.createdAt)}</span>
          </div>
        </div>
        {#if store.yaEnEmbudo(item.id)}
          <span class="tag">en el embudo</span>
        {:else}
          <button type="button" class="btn btn-secondary" disabled={enviando.includes(item.id)} onclick={() => enviar(item.id)}>Al embudo</button>
        {/if}
      </div>
    {/each}
  {/if}
{/each}
